import { getUniverseAggregateLabel } from '@weenat/client/dist/core/universes'
import { useIntl } from '@weenat/wintl'
import { RestrictionReason } from 'app/src/hooks/useIsAppAccessRestricted'
import { useToggleFeature } from 'app/state'
import { memo } from 'react'
import useUniverseBackgroundMapContext from '../universes/useUniverseBackgroundMapContext'
import { PlotListItemsVariants } from './PlotListItemMetricSummary'
import PlotListItemValue, { PlotSummaryValue } from './PlotListItemValue'
import PlotListItemValuesContainer from './PlotListItemValuesContainer'

interface SolarPlotListItemValuesProps {
  now: PlotSummaryValue
  max: PlotSummaryValue
  min: PlotSummaryValue
  metric: 'SSI' | 'SSI_MAX' | 'SSI_MIN' | 'PPFD' | 'PPFD_MAX' | 'PPFD_MIN'
  /** All values are restricted in the same way -- No need to pass isVirtualDevice  */
  isRestricted: boolean
  reason: RestrictionReason
  variant: PlotListItemsVariants
}

const SolarPlotListItemValues: FC<SolarPlotListItemValuesProps> = ({
  now,
  max,
  min,
  metric,
  isRestricted,
  reason,
  variant
}) => {
  const { t } = useIntl()
  const [{ smv }] = useToggleFeature()
  const { universeAggregate } = useUniverseBackgroundMapContext()

  return (
    <PlotListItemValuesContainer $isRestricted={isRestricted}>
      <PlotListItemValue
        isMainValue
        value={now}
        name={t(`map.universes.aggregate.${getUniverseAggregateLabel('real-time', smv)}`)}
        metric={metric}
        selected={universeAggregate === 'real-time'}
        isRestricted={isRestricted}
        reason={reason}
        variant={variant}
      />
      <PlotListItemValue
        value={min}
        metric={metric}
        name={t(`map.universes.aggregate.${getUniverseAggregateLabel('real-time-PPFD_MIN', smv)}`)}
        selected={
          universeAggregate === `real-time-SSI_MIN` || universeAggregate === `real-time-PPFD_MIN`
        }
        isRestricted={isRestricted}
        reason={reason}
        variant={variant}
      />
      <PlotListItemValue
        value={max}
        metric={metric}
        name={t(`map.universes.aggregate.${getUniverseAggregateLabel('real-time-PPFD_MAX', smv)}`)}
        selected={
          universeAggregate === `real-time-SSI_MAX` || universeAggregate === `real-time-PPFD_MAX`
        }
        isRestricted={isRestricted}
        reason={reason}
        variant={variant}
      />
    </PlotListItemValuesContainer>
  )
}

export default memo(SolarPlotListItemValues)
